import React, {useState, useContext, useEffect, useLayoutEffect, useRef} from 'react'
import {Button, Form, Row, Col}  from 'react-bootstrap'
import './AdminUtilitiesPanel.css'
import ConfirmDialog from './ConfirmDialog'
import Modal from 'react-bootstrap/Modal'
import {BsExclamationCircle} from 'react-icons/bs'
import UserContext from '../context/UserContext'
import DictionaryContext from '../context/DictionaryContext'
import moment from 'moment'
import Select from 'react-select'
import DeviceStatusDropdown from './DeviceStatusDropdown'
import styles from './InventoryForm.module.css'
import FormFields from './FormFields'


import { trackPromise } from 'react-promise-tracker'

function AdminUtilitiesPanel(props) {

    const userCtx = useContext(UserContext)
    const dictCtx = useContext(DictionaryContext)


    const devStatusToDeleteFieldName = "device_status_to_delete";
    const devStatusToResetFieldName = "device_status_to_reset";
    const fields = FormFields();
    const devStatusToDeleteField = fields[devStatusToDeleteFieldName];
    const devStatusToResetField = fields[devStatusToResetFieldName];

    const baseURL = process.env.REACT_APP_MODE === "TEST" ? process.env.REACT_APP_API_URL_TEST : process.env.REACT_APP_API_URL_PROD

    const [confirmDialogParams, setConfirmDialogParams] = useState({show:false})
    const [attestationStatus, setAttestationStatus] = useState(dictCtx.dict_attestion_status)
    const [devStatusesToDelete, setDevStatusesToDelete] = useState([])
    const [selectedStatusToDelete, setSelectedStatusToDelete] = useState(null);
    const [errors, setErrors] = useState({})
    const [reportOptions, setReportOptions] = useState({includeActive: 'OFF', includeDeleted: 'OFF'})
    const [selectedStatusToReset, setSelectedStatusToReset] = useState(null);
    const [devStatusesToReset, setDevStatusesToReset] = useState([])
    const scrollable = useRef();
    const inputRefs = useRef({});
    const [imagesDateRange, setImagesDateRange] = useState({date_from: '', date_to:''});

    const askToConfirmDefaults = {
        show: true,
        text: [],
        textClass: 'confirmation-text',
        cancel_button_text: 'Cancel',
        confirm_button_text: 'OK',
        confirm_button_variant: 'primary',
        onClose: () => {},
        title: 'Attention',
        title_class: 'alert-title',
        icon: <BsExclamationCircle />,
        confirm_only: false,
    };

    const confirmOnlyDefaults = {
        show: true,
        text: [],
        textClass: 'confirmation-text',
        cancel_button_text: null,
        confirm_button_text: 'OK',
        confirm_button_variant: 'primary',
        onClose: (result) => setConfirmDialogParams({show:false}),
        title: 'Attention',
        title_class: 'alert-title',
        icon: <BsExclamationCircle />,
        confirm_only: true,
    };

    const closeUtilityPanel = () => {
        props.closeUtilityPanel()
    }



    const resetRecerts = async () => {
        const url = `${baseURL}inventory_recerts/reset`
        await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
            },
        })
        .then((response) => {
            return response.json()
        })
        .then(data => {
            // console.log("Return from reset recerts", data)
            
        })
        .catch(e => {
            console.log("error resetting recerts", e)
            setConfirmDialogParams({
                show: true,
                text: ['Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                // prompt_class: styles['alert-prompt-black'],
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />
            })
        })

    }





    const updateAttestionStatus = async (status) => {
        
        const url = `${baseURL}dict_system_dictionaries/attestation_status/${status}`
        await fetch(url, {
            method: 'PATCH',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
            },
        })
        .then((response) => {
            return response.json()
        })
        .then(data => {
            // console.log("Return from change attestation status", data)
            // update attestation state in dictionaries
            props.onAttestationModeChange()
            
        })
        .catch(e => {
            console.log("error changing attestation status", e)
            setConfirmDialogParams({
                show: true,
                text: ['Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                // prompt_class: styles['alert-prompt-black'],
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />
            })
        })

    }



    const closeConfirmDialog = (result) => {
        setConfirmDialogParams({show: false})
        if (result === 'confirm') {
            //props.onClose(true)
            trackPromise(
                resetRecerts()
            )
        }
    }


    const resetAllRecerts = () => {
        setConfirmDialogParams({
            show: true,
            text: ['This will reset all recerts.', 'This operation is not reversable.', 'Are you sure you want to do it?'],
            textClass: 'confirmation-text',
            // prompt_class: styles['alert-prompt-black'],
            cancel_button_text: 'Cancel',
            confirm_button_text: 'Yes, reset all recerts',
            confirm_button_variant: 'primary',
            onClose: (result) => closeConfirmDialog(result),
            title: 'Attention',
            title_class: 'alert-title',
            icon: <BsExclamationCircle />,
            confirm_only: false,
        })
    }



    const changeAttestionStatus = (event) => {
        const newValue = event.target.checked ? 'ON' : 'OFF'
        
        setAttestationStatus(newValue)
        updateAttestionStatus(newValue)


    }


    const exportAllImages = () => {
      const url = `${baseURL}inventory_images/download/images-zip`
      const runExportAllImages = async () => {
          await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
            },
          })
          .then(response => {
            // console.log("response blob", response.body)
            return response.blob()
          }) 
          .then(zipBlob => {
            // console.log("zipBlob", zipBlob)
            const file_name = `Images_${moment.utc(new Date()).local().startOf('second').format('YYYY-MM-DD HH_mm_ss')}.zip`
            const objectURL = URL.createObjectURL(zipBlob);
            const link = document.createElement('a');
            link.href = objectURL;
            link.setAttribute('download', file_name);
            document.body.appendChild(link);
            link.click();
            // setTimeout(() => {
              link.parentNode.removeChild(link);
              window.URL.revokeObjectURL(objectURL);
            // }, 3000)
            
          })
          .catch(e => {
              console.log("error downloading all images", e)
              setConfirmDialogParams({
                  show: true,
                  text: ['Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                  textClass: 'confirmation-text',
                  // prompt_class: styles['alert-prompt-black'],
                  cancel_button_text: null,
                  confirm_button_text: 'OK',
                  confirm_button_variant: 'primary',
                  onClose: (result) => setConfirmDialogParams({show:false}),
                  title: 'Error',
                  title_class: 'alert-title',
                  icon: <BsExclamationCircle />,
                  confirm_only: true,
              })
          })
      }
        
      trackPromise(
        runExportAllImages()
      );

    }


    
    const onUploadFileClick = (e) => {
        // console.log("e.target.files", e.target.files)

        const uploadCSV = async (filename) => {
            const url = `${baseURL}noinventories/upload-csv`
            const fdata = new FormData()
            fdata.append("file", filename);
            await fetch(url, {
                method: 'POST',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    Accept: 'application/json'
                    // 'Content-Type': 'multipart/form-data'
                },
                body: fdata
            })
            .then((response) => {
                // if (response.ok) {
                    return response.json()
                // } else if (response.status === 500 && !!response.json()?.detail) 
                
            })
            .then(data => {
                // console.log("csv file uploaded", data)
                if (!!data && !!data.detail) {
                    setConfirmDialogParams({
                        show: true,
                        text: [data.detail, 'Please fix the error and try again', 'If the error persists please contact Support'],
                        textClass: 'confirmation-text',
                        prompt: 'The following error occured while trying to upload CSV file', 
                        prompt_class: 'alert-prompt-red',
                        cancel_button_text: null,
                        confirm_button_text: 'OK',
                        confirm_button_variant: 'primary',
                        onClose: (result) => setConfirmDialogParams({show:false}),
                        title: 'Error',
                        title_class: 'alert-title',
                        icon: <BsExclamationCircle />,
                        confirm_only: true,
                    })
                }
                
            })
            .catch(e => {
                console.log("error uploading csv file", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    prompt: 'Unexpected error happened while trying to save the item', 
                    prompt_class: 'alert-prompt-red',
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })
        }

        if (e.target.files.length > 0) {
            const files = Array.from(e.target.files)

            trackPromise(
                uploadCSV(files[0])
            )
        }        
    }

    // populate options for delete devices with selected status dropdown; disable options that shouldn't be deleted (device in use) 
    const getDeviceStatusOptionsForDelete = () => {
      const all_dev_statuses = dictCtx.dict_inventory_status;
      const statuses_allowed_to_delete = dictCtx.dict_status_to_hide;
      return all_dev_statuses.map(de => {
                return {
                    label: de.dictionary_detail,
                    value: de.dictionary_value, 
                    isDisabled: statuses_allowed_to_delete.findIndex(ad => ad === de.dictionary_value) < 0
                }
            })
    }



    // populate options for reset status of devices with selected status dropdown; disable options that should be preserved (any, but device in use) 
    const getDeviceStatusOptionsForReset = () => {
      const all_dev_statuses = dictCtx.dict_inventory_status;
      const statuses_not_allowed_to_reset = dictCtx.dict_status_to_hide;
      return all_dev_statuses.map(de => {
                return {
                    label: de.dictionary_detail,
                    value: de.dictionary_value, 
                    isDisabled: statuses_not_allowed_to_reset.findIndex(ad => ad === de.dictionary_value) >= 0
                }
            })
    }


    const deleteDevices = async () => {
        const url = `${baseURL}inventories/delete/by-device-status/${selectedStatusToDelete.value}`
        await fetch(url, {
            method: 'DELETE',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
            },
        })
        .then((response) => {
            return response.json()
        })
        .then(data => {
            // console.log("Return from delete devices ", data)
            setSelectedStatusToDelete(null);
            setConfirmDialogParams({...confirmOnlyDefaults,
                text: [data.message, `${data.deleted_count} device(s) deleted`],
                onClose: (result) => {setSelectedStatusToDelete(null); setConfirmDialogParams({show:false}); props.refreshUserItems();},
            })
            
        })
        .catch(e => {
            console.log("error deleting devices", e)
            setConfirmDialogParams({
                show: true,
                text: [e.message ?? 'Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                // prompt_class: styles['alert-prompt-black'],
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />
            })
        })

    }


    const statusSelected = (operation, status) => {
      // console.log("selected:", status)
      if (operation === 'delete by status') {
        setSelectedStatusToDelete(status);
        setErrors({...errors, [devStatusToDeleteFieldName]: null});
      } else if (operation === 'reset status') {
        setSelectedStatusToReset(status);
        setErrors({...errors, [devStatusToResetFieldName]: null});
      }

    }


    const closeDeleteDevicesConfirmDialog = (result) => {
        setConfirmDialogParams({show: false})
        if (result === 'confirm') {
            trackPromise(
                deleteDevices()
            )
        }
    }


    const deleteByStatus = () => {
      if (selectedStatusToDelete === null) {
        setErrors({...errors, [devStatusToDeleteFieldName]: "Please select device status to delete"});
      } else {
        setConfirmDialogParams({
            ...askToConfirmDefaults,
            text: [`This will delete all devices with ${selectedStatusToDelete.value} status.`, 'This operation is not reversable.', 'Are you sure you want to do it?'],
            confirm_button_text: 'Yes, delete these devices',
            onClose: (result) => closeDeleteDevicesConfirmDialog(result),
        })

      }
    }



    const downloadReport = () => {
        const url = `${baseURL}inventories/download/inventories-csv-combined?include_active=${reportOptions.includeActive === 'ON'}&include_deleted=${reportOptions.includeDeleted === 'ON'}`
        const active = reportOptions.includeActive === 'ON' ? 'active' : ''
        const deleted = reportOptions.includeDeleted === 'ON' ? 'deleted' : ''
        const and = !!active && !!deleted ? ' and ' : ''
        const filename = `All ${active}${and}${deleted} devices - ${moment.utc(new Date()).local().startOf('second').format('YYYY-MM-DD HH_mm_ss')}.csv`

        const download = async (filename, url) => {
            
            await fetch(url, {
                method: 'GET',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    Accept: 'application/json'
                    // 'Content-Type': 'multipart/form-data'
                },
            })
            .then(response => {
                console.log("response blob", response.body)
                return response.blob()
            }) 
            .then(blob => {
              // console.log("zipBlob", zipBlob)
              
              const objectURL = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = objectURL;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              // setTimeout(() => {
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(objectURL);
              // }, 3000)
              
            })
            .catch(e => {
                console.log("error uploading csv file", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    prompt: 'Unexpected error happened while trying to download the report', 
                    prompt_class: 'alert-prompt-red',
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })
        }


            trackPromise(
                download(filename,url)
            )
    }



    const resetStatuses = async () => {
        const url = `${baseURL}inventories/inventories/clear-device-status?device_status=${selectedStatusToReset.value}`
        await fetch(url, {
            method: 'PATCH',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
            },
        })
        .then((response) => {
            return response.json()
        })
        .then(data => {
          setSelectedStatusToReset(null);
            setConfirmDialogParams({
                ...confirmOnlyDefaults,
                text: [data.message],
                onClose: (result) => {setSelectedStatusToReset(null); setConfirmDialogParams({show:false}); props.refreshUserItems(); },
            })
            
        })
        .catch(e => {
            console.log("error deleting devices", e)
            setConfirmDialogParams({
                show: true,
                text: [e.message ?? 'Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                // prompt_class: styles['alert-prompt-black'],
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })
        })

    }

    const closeResetStatusConfirmDialog = (result) => {
        setConfirmDialogParams({show: false})
        if (result === 'confirm') {
            trackPromise(
                resetStatuses(selectedStatusToReset)
            )
        }
    }


    const deleteImages = async (date_from, date_to) => {
      const url = `${baseURL}inventory_images/disable/by-date-range?date_from=${date_from}&date_to=${date_to}`
        await fetch(url, {
            method: 'PATCH',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
            },
        })
        .then((response) => {
            return response.json()
        })
        .then(data => {
            setSelectedStatusToReset(null);
            setConfirmDialogParams({
                ...confirmOnlyDefaults,
                text: [data.message],
                onClose: (result) => {setConfirmDialogParams({show:false})},
            })
            
        })
        .catch(e => {
            console.log("error deleting devices", e)
            setConfirmDialogParams({
                show: true,
                text: [e.message ?? 'Unexpected error happened', 'Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                // prompt_class: styles['alert-prompt-black'],
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })
        })
    }

    const closeDeleteImagesConfirmDialog = (result) => {
      setConfirmDialogParams({show: false})
        if (result === 'confirm') {
            trackPromise(
                deleteImages(imagesDateRange.date_from, imagesDateRange.date_to)
            )
        }
    }

    const resetStatusAskToConfirm = (status) => {
      if (selectedStatusToReset === null) {
        setErrors({...errors, [devStatusToResetFieldName]: "Please select device status to reset"});
      } else {
        setConfirmDialogParams({
            ...askToConfirmDefaults,
            text: [`This will reset device status of all devices with ${selectedStatusToReset.value} status.`, 'This operation is not reversable.', 'Are you sure you want to do it?'],
            confirm_button_text: 'Yes, reset these statuses',
            onClose: (result) => closeResetStatusConfirmDialog(result),
        })

      }

    }



    const deleteImagesAskToConfirm = () => {
      // make sure that both dates have values, are correct dates and date from <= date to
      if (!!imagesDateRange.date_from && !!imagesDateRange.date_to && new Date(imagesDateRange.date_from) <= new Date(imagesDateRange.date_to)) {
        setConfirmDialogParams({
            ...askToConfirmDefaults,
            text: [`This will delete all images within ${imagesDateRange.date_from} - ${imagesDateRange.date_to} date range.`, 'This operation is not reversable.', 'Are you sure you want to do it?'],
            confirm_button_text: 'Yes, delete images',
            onClose: (result) => closeDeleteImagesConfirmDialog(result),
        })
      } else {
        let errFrom = '';
        let errTo = '';
        if (!!!imagesDateRange.date_from) {
          errFrom = 'Date From is required';
        }
        if (!!!imagesDateRange.date_to) {
          errTo = 'Date To is required';
        }
        if (!errFrom && !errTo && new Date(imagesDateRange.date_from) > new Date(imagesDateRange.date_to)) {
          errFrom = 'Date From should be <= Date To';
          errTo = 'Date To should be >= Date From';
        }
        setErrors({...errors, ['date_from']:errFrom, ['date_to']:errTo});
      }
    }


    const adjustAdminPanelHeight = () => {
        // calculate size of the table
        const html = document.getElementsByTagName("html");
        if (!!html) {
            // console.log("html", html)
            const htmlHeight = html[0].clientHeight;

            const tbl = scrollable.current;
            // console.log("scrollable", tbl)
            if (!!tbl) {
                const rect = tbl.getBoundingClientRect()
                // console.log("Scrollable position", rect )

                // calculate height
                const tblHeight = htmlHeight - rect.top - 70;
                // console.log("Scrollable new height", tblHeight )
                tbl.style.height = `${tblHeight}px`
            }

        }
    }


    // get dictionarries - we need fresh values just in case
    useEffect(() => {
        let isMounted = true

        const getDictionaries = async () => {
            const url = `${baseURL}dict_system_dictionaries/`;
            const skip = 0
            const limit=1000
    
            await fetch(`${url}?skip=${skip}&limit=${limit}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `${userCtx.token_type} ${userCtx.jwt}`
                    }
            })
            .then((response) => response.json())
            .then(data => {
                // console.log("dictionaries", data.data)
                if (!!data.data) {
                    if(isMounted) {
                        dictCtx.setAllDictionaries(data.data)
                        const attest_stat = data.data.filter(de => de.system_name === "ATTESTATION_STATUS" && de.dictionary_type ==="ATTESTATION_STATUS")
                        // console.log("setting attestation status", attest_stat)
                        setAttestationStatus(attest_stat[0].dictionary_value)

                        // set options for drop down for delete by status
                        const statuses = getDeviceStatusOptionsForDelete();
                        setDevStatusesToDelete(statuses);

                        // set options for drop down for reset status by status
                        const statuses2 = getDeviceStatusOptionsForReset();
                        // console.log("device statuses", statuses2)
                        setDevStatusesToReset(statuses2);
                    }
                }
            })
            .catch(e => {
                console.log("error getting dictionaries", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Unexpected error happened while trying to get dictionaries', 'Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    // prompt_class: styles['alert-prompt-black'],
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />
                })
            })
        }


        trackPromise(
            getDictionaries()
        )


        return () => {
            isMounted = false
        }
    
    },[props.show])


    useEffect(() => {
            const handleWindowResize = () => {
                adjustAdminPanelHeight();
            };
        
            window.addEventListener('resize', handleWindowResize);
        
            return () => {
              window.removeEventListener('resize', handleWindowResize);
            };
        }, []);
    
    
        useLayoutEffect(() => {
            adjustAdminPanelHeight();
        })


    return (
        <>
        <Modal 
            className={props.modal_class !== undefined ? props.modal_class : ''}
            size="lg" 
            show={props.show} 
            animation={false} 
            onHide={closeUtilityPanel} 
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className='d-flex inline-block align-items-center'>
                        Admin Utilities
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={`${styles.inventory_list_container} mx-auto`} ref={scrollable} >
                    <div className='mx-3 my-3 py-3 utilities_panel'>
                        <h4 className='my-3'>
                            Reset All Recerts
                        </h4>
                        <p>
                            This action resets certifications of all devices.
                        </p>
                        <p className='utilities_panel-warning'>
                            <span className='utilities_panel-warning-underlined'>Warning:</span> This operation will permanently reset (delete) certifications from all user devices. This action cannot be undone. Use this option only if you understand all consequences.
                        </p>
                        <Button onClick={resetAllRecerts} 
                            size='sm' variant="outline-primary" 
                            className='mx-2 font08' >
                            Reset All Recerts
                        </Button>
                    </div>
                    <div className='mx-3 my-3 py-3 utilities_panel'>
                        <h4 className='my-3'>
                            Set Attestation period ON or OFF.
                        </h4>
                        <p>
                            During Attestation period users will be asked to attest for correct information about every portable device they have in their possession.
                        </p>
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="attestation-switch"
                            className='mx-2 font08'
                            label={`Attestation Period is ${attestationStatus}`}
                            checked={attestationStatus === 'ON'}
                            onChange={changeAttestionStatus}
                        />
                    </div>
                    <div className='mx-3 my-3 py-3 utilities_panel'>
                        <h4 className='my-3'>
                            Upload No Inventory File.
                        </h4>
                        <p>
                            File should be in comma delimited format (csv) and has to have the following columns:
                        </p>
                        <ul>
                            <li>last_name</li>
                            <li>first_name</li>
                            <li>employee_acct</li>
                            <li>employee_email</li>
                            <li>manager_first_name</li>
                            <li>manager_last_name</li>
                            <li>manager_email</li>
                        </ul>

                        <input
                            id="fileUpload"
                            type="file"
                            multiple={false}
                            className="d-none"
                            accept='text/csv'
                            onChange={onUploadFileClick}
                            // disabled={fileLimit}
                        />

                        <label htmlFor="fileUpload">
                            <a className={`btn btn-outline-primary btn-sm mx-2` }>
                            Select file to upload
                            </a>
                        </label>
                    </div>
                    <div className='mx-3 my-3 py-3 utilities_panel'>
                        <h4 className='my-3'>
                            Export All Images
                        </h4>
                        <p>
                            This action creates a zip file with images for all devices.
                        </p>
                        
                        <Button onClick={exportAllImages} 
                            size='sm' variant="outline-primary" 
                            className='mx-2 font08' >
                            Export All Images
                        </Button>
                    </div>

                    {/* delete by status */}
                    <div className='mx-3 my-3 py-3 utilities_panel'>
                        <h4 className='my-3'>
                            Delete Devices by Status
                        </h4>
                        <p>
                            This action deletes all devices with the selected status.
                        </p>

                        <DeviceStatusDropdown 
                          statuses={devStatusesToDelete} 
                          onSelect={(status) => statusSelected('delete by status', status)}
                          // defaultValue={selectedStatusToDelete ?? ''}
                          value={selectedStatusToDelete}
                        />

                        {!!errors[devStatusToDeleteFieldName] &&
                            <div className={styles['invalid-feedback-override']}>
                                <BsExclamationCircle /> {errors[devStatusToDeleteFieldName]}
                            </div>
                        }
                        <p></p>
                        
                        <Button onClick={deleteByStatus} 
                            size='sm' variant="outline-primary" 
                            className='mx-2 font08' >
                            Delete Devices by Status
                        </Button>
                    </div>

                    {/* download all devices as csv file */}
                    <div className='mx-3 my-3 py-3 utilities_panel'>
                        <h4 className='my-3'>
                            Download Devices Report
                        </h4>
                        <p>
                            This action creates ccomma-delimited file (csv) with all devices.
                        </p>

                        <Form.Check // prettier-ignore
                            type="switch"
                            id="report-include-active"
                            className='mx-2 font08'
                            label={`Include Active Records ${reportOptions.includeActive}`}
                            checked={reportOptions.includeActive === 'ON'}
                            onChange={(e) => setReportOptions({...reportOptions, includeActive: e.target.checked ? 'ON' : 'OFF'})}
                        />

                        <Form.Check // prettier-ignore
                            type="switch"
                            id="report-include-deleted"
                            className='mx-2 font08'
                            label={`Include Deleted Records ${reportOptions.includeDeleted}`}
                            checked={reportOptions.includeDeleted === 'ON'}
                            onChange={(e) => setReportOptions({...reportOptions, includeDeleted: e.target.checked ? 'ON' : 'OFF'})}
                        />

                        {/* {!!errors[devStatusToDeleteFieldName] &&
                            <div className={styles['invalid-feedback-override']}>
                                <BsExclamationCircle /> {errors[devStatusToDeleteFieldName]}
                            </div>
                        } */}
                        <p></p>
                        
                        <Button onClick={downloadReport} 
                            disabled={reportOptions.includeActive === 'OFF' && reportOptions.includeDeleted === 'OFF'}
                            size='sm' variant="outline-primary" 
                            className='mx-2 font08' >
                            Download Report
                        </Button>
                    </div>


                    {/* Clear device status from all devices IN USE  */}
                    <div className='mx-3 my-3 py-3 utilities_panel'>
                        <h4 className='my-3'>
                            Reset Device Status from all devices still in use
                        </h4>
                        <p>
                            This action resets device status from all devices with status IN USE.
                        </p>

                        <DeviceStatusDropdown 
                          statuses={devStatusesToReset} 
                          onSelect={(status) => statusSelected('reset status',status)}
                          value={selectedStatusToReset}
                        />

                        {!!errors[devStatusToResetFieldName] &&
                            <div className={styles['invalid-feedback-override']}>
                                <BsExclamationCircle /> {errors[devStatusToResetFieldName]}
                            </div>
                        }
                        <p></p>
                        
                        <Button 
                            onClick={resetStatusAskToConfirm} 
                            size='sm' variant="outline-primary" 
                            className='mx-2 font08' >
                            Reset Status
                        </Button>
                    </div>


                    {/* Delete (mark as deleted) images in the date range  */}
                    <div className='mx-3 my-3 py-3 utilities_panel'>
                        <h4 className='my-3'>
                            Delete Device Images by Date Range
                        </h4>
                        <p>
                            This action deletes (marks as deleted) all device images within the specified date range.
                        </p>

                        <Row>
                          <Col>
                            <label htmlFor={'date_from'} className={styles.field_header} >Date From</label>
                            <input id='date_from' type='date'
                                // defaultValue={moment.utc(item[f.name]).startOf('minute').format('YYYY-MM-DDTHH:mm') ?? ''}
                                defaultValue=''
                                onChange={e => {
                                    // resetFieldErrors(f)
                                    // console.log("date from", e.target.value)
                                    setErrors({...errors, date_from:''});
                                    setImagesDateRange({...imagesDateRange, date_from: e.target.value ?? ''});
                                }}
                                ref={(el) => inputRefs.current['date_from'] = el}
                            />
                            {!!errors['date_from'] &&
                                <div className={styles['invalid-feedback-override']}>
                                    <BsExclamationCircle /> {errors['date_from']}
                                </div>
                            }
                          </Col>

                          <Col>
                            <label htmlFor={'date_to'} className={styles.field_header} >Date To</label>
                            <input id='date_to' type='date' 
                                // defaultValue={moment.utc(item[f.name]).startOf('minute').format('YYYY-MM-DDTHH:mm') ?? ''}
                                defaultValue=''
                                required
                                min='2020-01-01'
                                max={new Date().getDate()}
                                onChange={e => {
                                    setErrors({...errors, date_to:''})
                                    setImagesDateRange({...imagesDateRange, date_to: e.target.value ?? ''});
                                }}
                                ref={(el) => inputRefs.current['date_to'] = el}
                            />
                            {!!errors['date_to'] &&
                                <div className={styles['invalid-feedback-override']}>
                                    <BsExclamationCircle /> {errors['date_to']}
                                </div>
                            }
                          </Col>
                        </Row>

                        <p></p>
                        
                        <Button onClick={deleteImagesAskToConfirm} 
                            size='sm' variant="outline-primary" 
                            className='mx-2 font08' >
                            Delete Images
                        </Button>
                    </div>


                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={closeUtilityPanel} 
                    size='sm' variant="outline-primary" 
                    className='mx-2 font08' >
                    Close Utility Panel
                </Button>

                
            </Modal.Footer>
        </Modal>


        <div>

            

            {confirmDialogParams.show &&
                <ConfirmDialog 
                    show={confirmDialogParams.show}
                    iconColor='red'
                    iconSize='2rem'
                    icon={confirmDialogParams.icon}
                    title={confirmDialogParams.title}
                    title_class={confirmDialogParams.title_class}
                    text={confirmDialogParams.text}
                    textClass={confirmDialogParams.textClass}
                    prompt_class={confirmDialogParams?.prompt_class}
                    prompt={confirmDialogParams?.prompt}
                    cancel_button_text={confirmDialogParams.cancel_button_text}
                    confirm_button_text={confirmDialogParams.confirm_button_text}
                    confirm_button_variant={confirmDialogParams.confirm_button_variant}
                    onClose={confirmDialogParams.onClose}
                    confirm_only={confirmDialogParams.confirm_only}
                />
            }

        </div>
        </>
    )
}

export default AdminUtilitiesPanel
